import { inject, Injectable } from "@angular/core";
//import { ModelManager } from "../core";
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
// integration/angular/recommender.service.ts
import { 
  CategoryInput,
  FeatureInput,
  ImageRecommendationInput,
  ShortDescInput,
  LongDescInput,
  RecommendationResult,
  RecommendationStep,
  RecommendationContext,
  ShortDescRecommendation,
  LongDescRecommendation,
  CatalogRecommendation,
  CatalogInput
} from '../core/types';
import { ContextManager } from './context-manager';
//import { DataLoader } from '../core/data-loader';
import { catchError, switchMap, throwError } from 'rxjs';
import { Logger } from "../core/logging";

@Injectable({ providedIn: 'root' })
export class RecommenderService {
  private http = inject(HttpClient);
  private context = inject(ContextManager);
  //private modelManager = inject(ModelManager);
  //private dataLoader = inject(DataLoader);
  //private logger: Logger;

  getCatalogRecommendations(input: CatalogInput): Observable<RecommendationResult> {
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: 'catalog',
      currentStep: 'catalog',
      userQuery: input.userInput
    });
    console.log("Running http request for catalog recommendations");
    return this.http.post<RecommendationResult>('http://localhost:3001/api/catalog/recommend', { input }).pipe(
      tap(result => this.handleRecommendationSuccess('catalog', result)),
      catchError(error => this.handleRecommendationError(error, 'catalog'))
    );
    /* return this.http.post<RecommendationResult>('/api/category/recommend', { input }).pipe(
      tap(result => this.handleRecommendationSuccess('catalog', result)),
      catchError(error => this.handleRecommendationError(error, 'catalog'))
    ); */
    //return this.http.post<CatalogRecommendation[]>("/api/catalog/recommend", { input }).toPromise();
  }

  getCategoryRecommendation(input: CategoryInput): Observable<RecommendationResult> {
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: 'category',
      currentStep: 'category',
      userQuery: input.userInput
    });
    console.log('input',input)
    return this.http.post<RecommendationResult>('http://localhost:3001/api/category/recommend', { input }).pipe(
      tap(result => this.handleRecommendationSuccess('category', result)),
      catchError(error => this.handleRecommendationError(error, 'category'))
    );
    /* return this.http.post<RecommendationResult>('/api/category/recommend', input).pipe(
      tap(result => this.handleRecommendationSuccess('category', result)),
      catchError(error => this.handleRecommendationError(error, 'category'))
    ); */
  }



  getFeatureRecommendation(input: FeatureInput): Observable<RecommendationResult> {
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: 'feature',
      currentStep: 'features',
      userQuery: input.userInput
    });

    return this.http.post<RecommendationResult>('/api/features', input).pipe(
      tap(result => this.handleRecommendationSuccess('feature', result)),
      catchError(error => this.handleRecommendationError(error, 'feature'))
    );
  }

  getShortDescriptionRecommendation(input: ShortDescInput): Observable<RecommendationResult> {
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: 'shortDesc',
      currentStep: 'description',
      userQuery: input.userInput
    });

    return this.http.post<RecommendationResult>('/api/shortDesc', input).pipe(
      tap(result => this.handleRecommendationSuccess('shortDesc', result)),
      catchError(error => this.handleRecommendationError(error, 'shortDesc'))
    );
  }
  //Old way
  /* getShortDescription(input: ShortDescInput): Observable<RecommendationResult> {
    return this.http.post<RecommendationResult>(
      '/api/short-description',
      input
    );
  } */

  getLongDescriptionRecommendation(input: LongDescInput): Observable<RecommendationResult> {
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: 'longDesc',
      currentStep: 'description',
      userQuery: input.userInput
    });

    return this.http.post<RecommendationResult>('/api/longdesc', input).pipe(
      tap(result => this.handleRecommendationSuccess('longdesc', result)),
      catchError(error => this.handleRecommendationError(error, 'longdesc'))
    );
  }
  //Old way
  /* getLongDescription(input: LongDescInput): Observable<RecommendationResult> {
    return this.http.post<RecommendationResult>(
      '/api/long-description',
      input
    );
  } */
    analyzeImage(input: ImageRecommendationInput): Observable<RecommendationResult> {
      this.context.updateContext({
        loadingState: 'active',
        currentProcess: 'image',
        currentStep: 'image',
        userQuery: input.userInput,
        imageAnalysis: {
          embeddings: [],
          base64: input.imageBase64
        }
      });
  
      return this.http.post<RecommendationResult>('/api/analyze-image', input).pipe(
        tap(result => this.handleRecommendationSuccess('image', result)),
        catchError(error => this.handleRecommendationError(error, 'image'))
      );
    }
    private handleRecommendationSuccess(type: string, result: RecommendationResult) {
      console.log('result',result)
      this.context.updateContext({
        loadingState: 'complete',
        lastRecommendation: {
          type,
          result: result.recommendations,
          metadata: result.metadata
        },
        currentStep: this.getNextStep(type),
        ...this.updateStepState(type, result)
      });
    }
  
    private handleRecommendationError(error: any, type: string): Observable<never> {
      this.context.updateContext({
        loadingState: 'error',
        error: {
          message: error.message || `${type} recommendation failed`,
          code: `${type.toUpperCase()}_ERROR`
        }
      });
      return throwError(() => error);
    }
    private getNextStep(currentType: string): RecommendationStep {
      const stepOrder: Record<string, RecommendationStep> = {
        'category': 'category',
        'feature': 'features',
        'image': 'image',
        'description': 'description'
      };
      return stepOrder[currentType] || 'category';
    }
  
    private updateStepState(type: string, result: RecommendationResult) {
      const stateUpdates: Partial<RecommendationContext> = {};
      const currentContext = this.context.getCurrentContext()
      switch(type) {
        case 'category':
          stateUpdates.selectedCategory = result.recommendations[0]?.id;
          break;
        case 'feature':
          stateUpdates.extractedFeatures = result.recommendations.map(f => f.name);
          break;
        case 'shortDescription':
          stateUpdates.selectedShortDesc = (result.recommendations as ShortDescRecommendation[])[0].content;
          //stateUpdates.selectedShortDesc = result.recommendations[0].map(f => f.name);
          break;
        case 'longDescription':
          stateUpdates.selectedLongDesc = (result.recommendations as LongDescRecommendation[])[0].content;
          //stateUpdates.selectedLongDesc = result.recommendations[0].map(f => f.name);
          break;
        case 'image':
          stateUpdates.imageAnalysis = {
            ...currentContext.imageAnalysis, // Use spread from current context
            embeddings: result.metadata?.processingMetadata?.embeddings || [] // Updated property path
          };
          break;
      }
      
      return stateUpdates;
    }
  /* getImageRecommendation(input: ImageRecommendationInput): Observable<RecommendationResult> {
    return this.http.post<RecommendationResult>(
      '/api/image',
      input
    );
  } */
  //Recommenders commented out here in the shared library.  The are defined in the server
 /*  private recommenders = {
    category: new CategoryRecommender(
      {
        modelName: 'gpt-4',
        taxonomyPath: './assets/google-taxonomy.csv',
        validationStrictness: 'moderate'
      },
      this.modelManager,
      this.dataLoader
    ),
    feature: new FeatureRecommender(
      { modelName: 'gpt-4' },
      this.modelManager,
      this.dataLoader
    ),
    image: new ImageRecommender(
      {
        modelName: 'gpt-4-vision',
        maxImageSizeKB: 2048,
        visionModel: "gpt-4-vision-preview"
      },
      this.modelManager,
      this.dataLoader
    ),
    shortDesc: new ShortDescRecommender(
      {
        modelName: 'gpt-3.5-turbo',
        maxLength: 150,
        exampleCount: 5,
        keywordThreshold: 0.7,
        sanitizationRules: [/\b(?:free|discount)\b/gi, /<script.*?>.*?<\/script>/gi]
      },
      this.modelManager,
      this.dataLoader
    ),
    longDesc: new LongDescRecommender(
      {
        modelName: 'gpt-4',
        sectionWeights: { introduction: 0.3, features: 0.5 }
      },
      this.modelManager,
      this.dataLoader
    )
  }; */

  /* getCategoryRecommendations(input: CategoryInput) {
    return this.wrapRequest(
      this.recommenders.category.recommend(input),
      'category'
    );
  } */
  /*   getCategoryRecommendations(input: CategoryInput): Observable<RecommendationResult<CategoryRecommendation>> { 
        return from(
            this.wrapRequest(
            this.recommenders.category.recommend(input),
            'category'
            )
        ).pipe(
            catchError(() => of({ recommendations: [] } as RecommendationResult<CategoryRecommendation>)) // Ensure a valid output
        );
    }
      
  

  getFeatureRecommendations(input: FeatureInput) {
    return this.wrapRequest(
      this.recommenders.feature.recommend(input),
      'feature'
    );
  }

  analyzeImage(input: ImageRecommendationInput) {
    return this.wrapRequest(
      this.recommenders.image.recommend(input),
      'image'
    );
  }

  generateShortDescription(input: ShortDescInput) {
    return this.wrapRequest(
      this.recommenders.shortDesc.recommend(input),
      'shortDesc'
    );
  }

  generateLongDescription(input: LongDescInput) {
    return this.wrapRequest(
      this.recommenders.longDesc.recommend(input),
      'longDesc'
    );
  } */

  /* private wrapRequest<T>(
    request: Promise<RecommendationResult<T>>,
    type: keyof typeof this.recommenders
  ) {
    // Replace startRequest with context updates
    this.context.updateContext({ 
        loadingState: 'active',
        currentProcess: type
    });
    
    return request
      .then(result => {
        this.context.updateContext({
            loadingState: 'complete',
            lastRecommendation: {
              type,
              result: result.recommendations,
              metadata: result.metadata
            }
          });
        return result;
      })
      .catch(error => this.handleError(error, type));
  } */

  /* private wrapRequest<T>(
    request: Promise<RecommendationResult<T>>,
    type: keyof typeof this.recommenders
  ): Observable<RecommendationResult<T>> {
    // Replace startRequest with context updates
    this.context.updateContext({
      loadingState: 'active',
      currentProcess: type
    });
  
    return from(request).pipe(
      tap(result => {
        this.context.updateContext({
          loadingState: 'complete',
          lastRecommendation: {
            type,
            result: result.recommendations,
            metadata: result.metadata
          }
        });
      }),
      catchError(error => {
        this.handleError(error, type);
        return of({ recommendations: [] } as RecommendationResult<T>); // Ensure a valid return value
      })
    );
  } */
  

  /* private handleError(error: Error, type: string) {
    this.logger.error(`${type} recommendation error`, error);
    this.context.updateContext({
        loadingState: 'error',
        error: {
          message: this.getErrorMessage(type),
          code: `${type.toUpperCase()}_ERROR`
        }
      });
    return throwError(() => ({
      userMessage: this.getErrorMessage(type),
      technicalMessage: error.message,
      code: `${type.toUpperCase()}_ERROR`
    }));
  }

  private getErrorMessage(type: string): string {
    const messages: Record<string, string> = {
      category: $localize`Could not determine product category`,
      feature: $localize`Failed to generate product features`,
      image: $localize`Image analysis failed`,
      shortDesc: $localize`Description generation error`,
      longDesc: $localize`Detailed description creation failed`
    };
    
    return messages[type] || $localize`Recommendation service error`;
  } */

  /* // Multi-step recommendation flow
  fullProductRecommendationFlow(input: CategoryInput) {
    return this.getCategoryRecommendations(input).pipe(
      switchMap((categoryResult:RecommendationResult) => {
        if (!categoryResult.recommendations.length) {
          throw new Error('No valid categories found');
        }
        
        return this.getFeatureRecommendations({
          ...input,
          category: categoryResult.recommendations[0].id
        });
      }),
      switchMap((featureResult:RecommendationResult) => 
        this.generateLongDescription({
          ...input,
          features: featureResult.recommendations.map(f => f.name)
        })
      ),
      catchError(error => this.handleError(error, 'full_flow'))
    );
  } */
  /* fullProductRecommendationFlow(input: CategoryInput): Observable<RecommendationResult<LongDescRecommendation>> {
    return from(this.getCategoryRecommendations(input)).pipe(
        switchMap((categoryResult: RecommendationResult<CategoryRecommendation>) => {
          if (!categoryResult.recommendations.length) {
            return of({ recommendations: [] } as RecommendationResult<LongDescRecommendation>); // Ensures a valid return type
          }
      
          return from(this.getFeatureRecommendations({
            ...input,
            category: categoryResult.recommendations[0].id
          }));
        }),
        switchMap((featureResult: RecommendationResult<FeatureRecommendation>) => {
          if (!featureResult?.recommendations.length) {
            return of({ recommendations: [] } as RecommendationResult<LongDescRecommendation>);
          }
      
          return from(this.generateLongDescription({
            ...input,
            features: featureResult.recommendations.map(f => f.name)
          }));
        }),
        catchError(error => this.handleError(error, 'full_flow'))
      );
      
      
  } */

      /* fullProductRecommendationFlow(input: CategoryInput): Observable<RecommendationResult<LongDescRecommendation>> {
        return from(this.getCategoryRecommendations(input)).pipe(
          switchMap((categoryResult: RecommendationResult<CategoryRecommendation>) => {
            if (!categoryResult.recommendations.length) {
              return EMPTY; // Completes without error
            }
      
            return from(this.getFeatureRecommendations({
              ...input,
              category: categoryResult.recommendations[0].id
            }));
          }),
          switchMap((featureResult: RecommendationResult<FeatureRecommendation>) => {
            if (!featureResult?.recommendations.length) {
              return EMPTY;
            }
      
            return from(this.generateLongDescription({
              ...input,
              features: featureResult.recommendations.map(f => f.name)
            }));
          }),
          catchError(error => this.handleError(error, 'full_flow'))
        );
      } */
      

}